
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1311Dialog extends Serenity.EntityDialog<Report_1311Row, any> {
        protected getFormKey() { return Report_1311Form.formKey; }
        protected getIdProperty() { return Report_1311Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1311Row.localTextPrefix; }
        protected getNameProperty() { return Report_1311Row.nameProperty; }
        protected getService() { return Report_1311Service.baseUrl; }
        protected getDeletePermission() { return Report_1311Row.deletePermission; }
        protected getInsertPermission() { return Report_1311Row.insertPermission; }
        protected getUpdatePermission() { return Report_1311Row.updatePermission; }

        protected form = new Report_1311Form(this.idPrefix);

    }
}